import clsx from "clsx";
import React from "react";
import { useForm } from "react-hook-form";
import { EmailField } from "../../common/forms/components/EmailField";
import { USER_ROLE_NEWS } from "../../common/roles/constants";
import useRolesVisibility from "../../common/roles/useRolesVisibility";
import { RequiredRoles } from "../../search/criteria/components/common/requiredRoles";

export function Newsletter() {
	const { hasRequiredRoles } = useRolesVisibility(
		RequiredRoles.showFor([USER_ROLE_NEWS]),
	);
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm();

	if (hasRequiredRoles) {
		return null;
	}

	const onSubmit = (data) => {
		window.location = "/newsletter-subscribe?prefillEmail=" + data.email;
	};

	return (
		<section className="search-results-newsletter">
			<p className="h5">Subscribe to ch-aviation Newsletter</p>

			<p>
				Stay informed with ch-aviation’s latest articles! Subscribe NOW
				to receive our Commercial Aviation and/or Business Jets
				Newsletter
			</p>

			<form
				className={clsx("grid justify-space-between")}
				id="newsletter-subscription-form"
				onSubmit={handleSubmit(onSubmit)}
				aria-label="Newsletter"
				autoComplete="off"
			>
				<EmailField
					control={control}
					errors={errors}
					label="Enter your Email here:"
					id="newsletter-subscription-email"
					name="email"
					placeholder="your.name@youremail.com"
					required
				/>

				<button
					type="submit"
					className="btn btn--primary"
					form="newsletter-subscription-form"
				>
					Subscribe
				</button>
			</form>
		</section>
	);
}
